import React from "react";

// Shared per-row notes dialog for the Regular and Call Back tables. The parent
// owns which row is open (notesIndex, null = closed); this component owns the
// <dialog> element and its open/close mechanics.
export default function NotesDialog({ titleId, rows, notesIndex, readOnly, onChange, onClose }) {
  const dialogRef = React.useRef(null);

  React.useEffect(() => {
    if (notesIndex !== null) {
      dialogRef.current?.showModal();
    }
  }, [notesIndex]);

  const closeNotes = React.useCallback(() => {
    dialogRef.current?.close();
  }, []);

  const activeRow = notesIndex !== null ? rows[notesIndex] : null;

  return (
    <dialog
      ref={dialogRef}
      className="notes-dialog"
      aria-labelledby={titleId}
      onClose={onClose}
      onClick={(e) => { if (e.target === dialogRef.current) closeNotes(); }}
    >
      {activeRow !== null && (
        <div className="notes-dialog-inner">
          <div className="notes-dialog-header">
            <h3 id={titleId} className="notes-dialog-title">
              {activeRow.day} — Notes
            </h3>
            <button
              type="button"
              className="notes-dialog-close"
              aria-label="Close notes"
              onClick={closeNotes}
            >
              ×
            </button>
          </div>
          <textarea
            className="notes-dialog-textarea"
            rows="4"
            value={activeRow.notes}
            disabled={readOnly}
            autoFocus
            placeholder="Add a note for this day…"
            onChange={(e) => onChange(notesIndex, "notes", e.target.value)}
          />
          {!readOnly && (
            <p className="notes-dialog-hint">Changes are saved automatically</p>
          )}
        </div>
      )}
    </dialog>
  );
}
